G.Modify = function() {

  //in case that G.Modify was invoked without new
  if (this === G){
    return new G.Modify();
  }

  Phaser.Group.call(this,game);

  G.Modify.instance = this;

  this.onLevelObjChange = new Phaser.Signal();
  this.onCurrentObjChange = new Phaser.Signal();
  this.onObjDestroy = new Phaser.Signal();

  this.inputBlocker = new G.ModifyInputBlocked();
  this.add(this.inputBlocker);

  game.stage.disableVisibilityChange = false;
  game.paused = false;

  obj = game.state.getCurrentState();

  if (obj === game.state.getCurrentState()) {
    game.state.getCurrentState().children = game.world.children;
  }

  this.objectName = 'WORLD';

  this.currentLevel = [];

  this.currentChildIndex = 0;
  this.currentPropIndex = 0;
  this.mods = [];

  this.gfx = game.add.graphics();
  this.gfx.fixedToCamera = true;
  this.add(this.gfx);
  this.obj = obj;


  this.propGroup = this.add(new G.ModifyPropGroup(this));
  this.childrenPropNames = this.getChildrenPropNames();


  this.buttonGroup = new G.ModifyButtonGroup();
  this.add(this.buttonGroup);

  this.childList = new G.ModifyChildList();
  this.add(this.childList);


  this.addKeyboardControlls();

  this.bottomBar = this.add(new G.ModifyBottomBar());

  this.frameSelector = this.add(new G.ModifyFrameSelector());

  this.frameSelector.onFrameClicked.add(this.changeFrame,this);

  this.animationEditor = new G.ModifyAnimationEditor(this);
  this.add(this.animationEditor);

  this.removeCash = {};


  this.codeGenerator = new G.ModifyCodeGenerator(this);

  this.defaultNewObjectsNames = true;
  this.hideGroupTxt = false;


  if (!game.state.states.MODIFYEMPTYSTATE){
    game.state.add('MODIFYEMPTYSTATE',{
      create: function(){
        new G.Modify();
      }
    });
  };

  this.domLayer = new G.ModifyDOMLayer(this);

  game.input.onDown.add(this.processClick,this);

};

G.Modify.prototype = Object.create(Phaser.Group.prototype);

G.countChildren = function(group) {
  var amount = 1;
  if (group.children && group.children.length > 0) {
    group.children.forEach(function(child) {
      amount += G.countChildren(child);
    });
  } 
  return amount;

};

G.Modify.prototype.removeCashObjToString = function(levelObjTxt) {

  if (!this.removeCash[levelObjTxt]) return '';

  var str = '\tREMOVED:'
  for (var i = 0; i < this.removeCash[levelObjTxt].length; i++) {
    str += '\t\t'+this.removeCash[levelObjTxt][i]+'\n'
  }
  return str;

};

G.Modify.prototype.removeObject = function() {

  console.log('removeObject');

  var obj = this.getCurrentObject();
  console.log(obj);
  if (!obj) return;

  var lvlObjName = this.currentLevel.join('/') || (this.currentLevel[0] || game.state.current);
  var objName = this.childrenPropNames[this.currentChildIndex].toString();

  //check if object was at start of Modify
  //if not it means that it was created and removed after init
  //so there is no point of keeping record of that object

  if (!obj.___NEWOBJECT) {

  }
  if (!this.removeCash[lvlObjName]) this.removeCash[lvlObjName] = [];
  this.removeCash[lvlObjName].push(objName);

  obj.destroy();
  this.refreshLevel();

};

G.Modify.prototype.refreshLevel = function() {

  this.currentLevel = this.currentLevel;
  this.childrenPropNames = this.getChildrenPropNames();
  this.onLevelObjChange.dispatch();
  //this.currentChildIndex = 0;
  //this.makeTexts();
};

G.Modify.prototype.addToGroup = function(parent,obj) {

  if (parent == game.world || parent == game.state.getCurrentState()) {
    parent = game.world;
    obj.x = game.camera.x+game.width*0.5;
    obj.y = game.camera.y+game.height*0.5;
  }
  if (parent.add) {
    parent.add(obj);
  }else if (parent.addChild) {
    parent.addChild(obj);
  }

  var name;

  var lvlObj = this.getCurrentLevelObject();

  if (this.defaultNewObjectsNames){
    name = 'child_'+lvlObj.children.length;
  }else {
    name = prompt('Enter object name');
  }



  if (name) {

    obj.___LABEL = name;

    if (parent == game.world) {
      game.state.getCurrentState()[name] = obj;
    }else {
      parent[name] = obj;
    }
  }

};

G.Modify.prototype.addGroup = function() {

  var obj = this.getCurrentLevelObject();
  var group = game.make.group();
  group.___NEWOBJECT = true;
  this.addToGroup(obj,group);

  this.refreshLevel();

};

G.Modify.prototype.addImage = function() {

  var obj = this.getCurrentLevelObject();
  var image = new G.Image(0,0,'__missing',0.5,null);
  image.___NEWOBJECT = true;
  this.addToGroup(obj,image);

  this.refreshLevel();

  return image;

};


G.Modify.prototype.addButton = function(){

  var obj = this.getCurrentLevelObject();
  var image = new G.Button(0,0,'__missing',function(){},this);
  image.___NEWOBJECT = true;
  this.addToGroup(obj,image);

  this.refreshLevel();

};

G.Modify.prototype.addOneLineText = function() {

  var obj = this.getCurrentLevelObject();

  var fonts = Object.keys(game.cache._cache.bitmapFont);
  var txt = new G.OneLineText(0,0,fonts[0],'TEXT',50,300,0.5,0.5);
  txt.cacheAsBitmap= false;
  this.addToGroup(obj,txt);

  this.refreshLevel();
};

G.Modify.prototype.addMultiLineText = function() {

  var obj = this.getCurrentLevelObject();

  var fonts = Object.keys(game.cache._cache.bitmapFont);
  var txt = new G.MultiLineText(0,0,fonts[0],'TEXT',50,300,300,'center',0.5,0.5);
  txt.cacheAsBitmap= false;
  this.addToGroup(obj,txt);

  this.refreshLevel();

};

G.Modify.prototype.update = function() {

  this.updateKeyboard();

  this.redrawGfx();
  this.propGroup.update();

  if (this.hideGroupTxt) {
    //this.groupTxt.visible = false;
    this.childList.hideList();
    this.propGroup.cameraOffset.y = this.childList.cameraOffset.y+50;
  }else {
    this.childList.showList();
    //this.groupTxt.visible = true;
    this.propGroup.cameraOffset.y = this.childList.cameraOffset.y+this.childList.height+30;
  }

  this.frameSelector.update();

  this.bottomBar.x = game.world.bounds.x;
  this.bottomBar.y = game.world.bounds.y + game.height - this.bottomBar.height;

  for (var i = 0; i < this.children.length; i++){
    this.children[i].update();
  }

};

G.Modify.prototype.getChildrenPropNames = function() {

  game.world.bringToTop(this);

  var result = [];

  var obj = this.getCurrentLevelObject();
  var nameObj = obj;
  if (obj === game.world) {
    nameObj = game.state.getCurrentState();
  }

  var foundObjList = [];

  for (var i = 0; i < obj.children.length; i++) {

    var found = false;
    var child = obj.children[i];

    if (child === this) {
      result.push(['G.MODIFY-EDITOR']);
      continue;
    }

    if (child.___LABEL){
      result.push([child.___LABEL]);
      continue;
    }

    for (var prop in nameObj) {

      if (prop == 'children' || prop == 'cursor') {
        continue;
      }

      if (!found && child === nameObj[prop]) {
        found = true;
        child.___LABEL = prop;
        result.push([prop]);
      }



      if (Array.isArray(nameObj[prop]) && prop !== 'children') {

        for (var j = 0; j < nameObj[prop].length; j++) {
          if (!found && child === nameObj[prop][j]) {
            found = true;
            result.push([prop,j]);
          }
        }

      }

    }

    if (!found) {
      result.push(['children',i]);
    }

  }

  return result;

};

G.Modify.prototype.getCurrentObject = function() {
  return this.getCurrentLevelObject().children[this.currentChildIndex];
};

G.Modify.prototype.changeFrame = function(newFrame) {

  console.log(newFrame);

  var obj = this.getCurrentObject();

  this.saveInitPropValue('frameName',newFrame);

  if (obj.loadTexture) {
    G.changeTexture(obj,newFrame);
  }

};

G.Modify.prototype.getCurrentLevelObject = function() {

  var obj = this.obj;

  for (var i = 0; i < this.currentLevel.length; i++) {
    obj = obj[this.currentLevel[i]];
  }

  return obj;


};

G.Modify.prototype.redrawGfx = function() {

  this.gfx.clear();


  //whole group

  var obj = this.getCurrentLevelObject();

  if (obj !== game.state.getCurrentState()) {

    var bounds = obj.getLocalBounds();
    this.gfx.lineStyle(3, 0xff0000, 0.2);
    this.gfx.drawRect(
      obj.worldPosition.x+bounds.x,
      obj.worldPosition.y+bounds.y,
      bounds.width,
      bounds.height);

    this.gfx.beginFill(0x000000,0.5);
    this.gfx.drawRect(obj.worldPosition.x-10,obj.worldPosition.y-10,20,20);

  }


  this.gfx.beginFill(0x000000,0);


  //childrens

  this.childrenPropNames.forEach(function(key,index) {

    var activeObj = index == this.currentChildIndex;
    this.gfx.lineStyle(activeObj ? 3 : 1, 0x0000ff, activeObj ? 1 : 0.2);
    var obj = this.getCurrentLevelObject().children[index];
    if (!obj) return;
    var bounds = obj.getBounds();
    var localBounds = obj.getLocalBounds();
    this.gfx.drawRect(
      obj.worldPosition.x+localBounds.x*obj.scale.x,
      obj.worldPosition.y+localBounds.y*obj.scale.y,
      bounds.width*obj.scale.x,
      bounds.height*obj.scale.y
    );

    if (activeObj && obj.maxUserWidth && !obj.maxUserHeight) {

      this.gfx.lineStyle(2,0x00ff00,0.5);
      this.gfx.drawRect(
        obj.worldPosition.x - (obj.anchor.x*obj.maxUserWidth),
        obj.worldPosition.y - (obj.anchor.y*obj.height),
        obj.maxUserWidth,
        obj.height
      );
    }else if (activeObj && obj.maxUserWidth && obj.maxUserHeight) {

      this.gfx.lineStyle(2,0x00ff00,0.5);
      this.gfx.drawRect(
        obj.worldPosition.x - (obj.anchor.x*obj.maxUserWidth),
        obj.worldPosition.y - (obj.anchor.y*obj.maxUserHeight),
        obj.maxUserWidth,
        obj.maxUserHeight
      );
    }

  },this);

  var currentObj = this.getCurrentObject();
  if (!currentObj) return;

};


G.Modify.prototype.addKeyboardControlls = function() {

  this.keys = game.input.keyboard.addKeys({
    'Q':Phaser.Keyboard.Q,
    'A':Phaser.Keyboard.A,
    'E':Phaser.Keyboard.E,
    'UP':Phaser.Keyboard.UP,
    'ONE':Phaser.Keyboard.ONE,
    'TWO':Phaser.Keyboard.TWO,
    'DOWN':Phaser.Keyboard.DOWN,
    'RIGHT':Phaser.Keyboard.RIGHT,
    'LEFT':Phaser.Keyboard.LEFT,
    'ALT':Phaser.Keyboard.ALT,
    'Z':Phaser.Keyboard.Z,
    'X':Phaser.Keyboard.X,
    'C':Phaser.Keyboard.C,
    'U':Phaser.Keyboard.U,
    'PLUS': 107,
    'MINUS': 109,
    'ESC': Phaser.Keyboard.ESC,
    'NUM8': 104,
    'NUM5': 101,
    'NUM4': 100,
    'NUM6': 102,
    'NUM2': 98,
    'NUM7': 103,
    'NUM9': 105,
    'NUMSTAR': 106,
    'SPACE' : Phaser.Keyboard.SPACEBAR,
    'V': Phaser.Keyboard.V,
    'L': Phaser.Keyboard.L,
    'I': Phaser.Keyboard.I,
    'P': Phaser.Keyboard.P,
    'O': Phaser.Keyboard.O,
    'M': Phaser.Keyboard.M,
    'DEL': Phaser.Keyboard.DELETE,
    'sqBracketOpen': 219,
    'sqBracketClose': 221,
    'SHIFT': Phaser.Keyboard.SHIFT

  });


  this.keys.sqBracketOpen.onDown.add(function(){
    if (this.keys.SHIFT.isDown) {
      this.objToBottom();
    }else {
      this.objMoveDown();
    }
  },this);

  this.keys.sqBracketClose.onDown.add(function(){
    if (this.keys.SHIFT.isDown) {
      this.objToTop();
    }else {
      this.objMoveUp();
    }
  },this);



  this.keys.frameCounter = 0;

  this.keys.L.onDown.add(function(){
    var lvlObj = this.getCurrentLevelObject();
    var obj = this.getCurrentObject();

    this.domLayer.openInputDiv(
    (obj.___LABEL || 'obj')+' | label',
    obj.___LABEL || '',
    function(value){
      if (lvlObj[value] === undefined) {

        if (obj.___LABEL){
          delete lvlObj[obj.___LABEL];
        }

        lvlObj[value] = obj;
        obj.___LABEL = value;
        this.refreshLevel();
      }
    },
    this,'string');

  },this);


  //change children +1
  this.keys.Q.onDown.add(function() {
    this.changeCurrentChildrenIndex(this.currentChildIndex+1);
  },this);

  //change children -1
  this.keys.A.onDown.add(function() {
    console.log('children -1');
    this.changeCurrentChildrenIndex(this.currentChildIndex-1);
  },this);

  this.keys.E.onDown.add(function() {
    this.exportChanges();
  },this);

  //restar to initial position
  this.keys.NUM5.onDown.add(function() {

    var obj = this.getCurrentObject();

    if (!obj) return;

    obj.scale.setTo(1);
    obj.angle = 0;
    obj.alpha = 1;
    obj.visible = true;
    obj.anchor.setTo(0.5);

  },this);

  //enter child
  this.keys.TWO.onDown.add(function() {
    var obj = this.getCurrentObject();
    if (obj.children.length > 0) {
      this.currentLevel = this.currentLevel.concat(this.childrenPropNames[this.currentChildIndex]);
      this.childrenPropNames = this.getChildrenPropNames();
      this.currentChildIndex = 0;
      this.makeTexts();
    }
  },this);

  //exit child
  this.keys.ONE.onDown.add(function() {

    if (this.currentLevel.length == 0) return;
    //for arrays - children,1 -> splice 2
    this.currentLevel = typeof this.currentLevel[this.currentLevel.length-1] === 'number' ? this.currentLevel.splice(0,this.currentLevel.length-2) : this.currentLevel.splice(0,this.currentLevel.length-1);
    this.childrenPropNames = this.getChildrenPropNames();
    this.currentChildIndex = 0;
    this.makeTexts();

  },this);

  //kill modify
  this.keys.ESC.onDown.add(this.turnOff,this);

  //change alpha settings
  this.keys.V.onDown.add(function(){
    this.alpha = this.alpha == 1 ? 0.1 : 1;
  },this);

  //mark obj as constructor
  this.keys.O.onDown.add(function(){
    var obj = this.getCurrentObject();
    if (obj instanceof Phaser.Group) {
      obj.___CONSTRUCTOR = true;
    }
  },this);

  //generate code
  this.keys.P.onDown.add(function(){
    var obj = this.getCurrentObject();
    var str = this.codeGenerator.start(obj);
  },this);


  this.keys.C.onDown.add(function(){
    var pointer = game.input.activePointer;
    var newObj = this.addImage();
    this.setNewCurrentChildren(newObj);
    this.moveCurrentObjectToWorldPos(pointer.x,pointer.y);

  },this);

  //go to modify empty state
  this.keys.I.onDown.add(function(){
    if (this.pressCounterI === undefined) {
      this.pressCounterI = 0;
    }

    this.pressCounterI++;

    if (this.pressCounterI == 3){
      game.state.start('MODIFYEMPTYSTATE');
    }

    game.time.events.add(1000,function(){
      this.pressCounterI = 0;
    },this);
  },this);

  this.keys.DEL.onDown.add(this.removeObject,this);

  this.keys.NUMSTAR.onDown.add(function(){

    console.log('numstar');

    if (this.frameSelector.opened) {
      this.frameSelector.close();
    }else{
      this.frameSelector.open();
    }

  },this);

  this.keys.U.onDown.add(function(){
    this.hideGroupTxt = !this.hideGroupTxt;
  },this);

};

G.Modify.prototype.turnOff = function() {

  if (this.escPressed === undefined){
    this.escPressed = 0;
  }

  this.escPressed++;
  game.time.events.add(2000,function(){
    this.escPressed = 0;
  },this)

  if (this.escPressed < 5) return;


  for (key in this.keys) {

      if (this.keys[key].onDown) {
        this.keys[key].onDown.removeAll();
      }

    }

    this.gfx.destroy();
    this.levelTxt.destroy();
    this.propGroup.destroy();
    this.groupTxt.destroy();

    this.destroy();

};


G.Modify.prototype.modifyCurrentObjProp = function(prop,value){

  var obj = this.getCurrentObject();
  this.saveInitPropValue(prop,value);
  G.StorageUtils.setObjProp(obj,prop,value);

};

G.Modify.prototype.saveInitPropValue = function(prop,newVal){

  var obj = this.getCurrentObject();

  if (Array.isArray(prop)) prop = prop.join('.');

  var val = G.StorageUtils.getObjProp(obj,prop);

  //exit if nothing changes
  if (val === newVal) return;

  if (!obj.___initState) obj.___initState = {};

  //if there was init value before, dont overwrite it
  if (typeof obj.___initState[prop] !== 'undefined'){
    return;
  }

  obj.___initState[prop] = G.StorageUtils.getObjProp(obj,prop);

};

G.Modify.prototype.updateKeyboard = function() {

  var obj = this.getCurrentObject();

  if(!obj) return;

  this.keys.frameCounter++;



  var val = 1;
  var proc = true;
  if (this.keys.Z.isDown){
    if (this.keys.frameCounter % 5 != 0) {
      proc = false;
    }
  }


  //position

  if (this.keys.X.isDown) {
    val = 5;
  }
  if (this.keys.C.isDown) {
    val = 20;
  }

  if (proc && this.keys.UP.isDown) {
    this.modifyCurrentObjProp('y',obj.y-val);
    //obj.position.y-=val;
  }
  if (proc && this.keys.DOWN.isDown) {
    this.modifyCurrentObjProp('y',obj.y+val);
    //obj.position.y+= val;
  }
  if (proc && this.keys.LEFT.isDown) {
    this.modifyCurrentObjProp('x',obj.x-val);
    //obj.position.x-=val;
  }
  if (proc && this.keys.RIGHT.isDown) {
    this.modifyCurrentObjProp('x',obj.x+val);
    //obj.position.x+= val;
  }



  val = 0.025;

  if (this.keys.X.isDown) {
    val = 0.05;
  }
  if (this.keys.C.isDown) {
    val = 0.1;
  }

  if (proc && this.keys.NUM8.isDown) {
    this.modifyCurrentObjProp('scale.y',obj.scale.y+val);
    //obj.scale.y+=val;
  }
  if (proc && this.keys.NUM2.isDown) {
    this.modifyCurrentObjProp('scale.y',obj.scale.y-val);
    obj.scale.y-= val;
  }
  if (proc && this.keys.NUM4.isDown) {
    this.modifyCurrentObjProp('scale.x',obj.scale.x-val);
    //obj.scale.x-=val;
  }
  if (proc && this.keys.NUM6.isDown) {
    this.modifyCurrentObjProp('scale.x',obj.scale.x+val);
    //obj.scale.x+= val;
  }

  if (proc && this.keys.PLUS.isDown) {
    this.modifyCurrentObjProp('scale.x',obj.scale.x+val);
    this.modifyCurrentObjProp('scale.y',obj.scale.y+val);
    //obj.scale.x += val;
    //obj.scale.y += val;
  }
  if (proc && this.keys.MINUS.isDown) {
    this.modifyCurrentObjProp('scale.x',obj.scale.x-val);
    this.modifyCurrentObjProp('scale.y',obj.scale.y-val);
    //obj.scale.x -= val;
    //obj.scale.y -= val;
  }

  //obj.scale.x = parseFloat(obj.scale.x.toFixed(3));
  //obj.scale.y = parseFloat(obj.scale.y.toFixed(3));



  //angle


  val = 1;

  if (this.keys.X.isDown) {
    val = 2;
  }
  if (this.keys.C.isDown) {
    val = 5;
  }

  if (proc && this.keys.NUM7.isDown) {
    this.modifyCurrentObjProp('angle',obj.angle-val);
    //obj.angle+=val;
  }
  if (proc && this.keys.NUM9.isDown) {
    this.modifyCurrentObjProp('angle',obj.angle+val);
    //obj.angle-= val;
  }


  if (this.keys.SPACE.isDown) {

    this.modifyCurrentObjProp('x',Math.floor(obj.x/5)*5);
    this.modifyCurrentObjProp('y',Math.floor(obj.y/5)*5);

    this.modifyCurrentObjProp('scale.x',Math.floor(obj.scale.x/0.025)*0.025);
    this.modifyCurrentObjProp('scale.y',Math.floor(obj.scale.y/0.025)*0.025);

    this.modifyCurrentObjProp('angle',Math.floor(obj.angle));

  }


};

G.Modify.prototype.currentLevelGoUp = function(){
  if (this.currentLevel.length == 0) return;
    //for arrays - children,1 -> splice 2
  this.currentLevel = typeof this.currentLevel[this.currentLevel.length-1] === 'number' ?
  this.currentLevel.splice(0,this.currentLevel.length-2) :
  this.currentLevel.splice(0,this.currentLevel.length-1);
  this.childrenPropNames = this.getChildrenPropNames();
  this.currentChildIndex = 0;

  this.onLevelObjChange.dispatch();

};

G.Modify.prototype.currentLevelGoDown = function(childIndex){

  console.log(arguments);

  console.log(this.childrenPropNames[childIndex]);

  this.currentLevel = this.currentLevel.concat(this.childrenPropNames[childIndex]);
  this.childrenPropNames = this.getChildrenPropNames();
  this.currentChildIndex = 0;
  this.onLevelObjChange.dispatch();

};

G.Modify.prototype.changeCurrentChildrenIndex = function(newIndex) {

  this.currentChildIndex = newIndex;

  if (this.currentChildIndex < 0) {
    this.currentChildIndex = this.childrenPropNames.length-1;
  }

  if (this.currentChildIndex >= this.childrenPropNames.length) {
    this.currentChildIndex = 0;
  }

  this.onCurrentObjChange.dispatch();

  //this.refreshTexts();

};


G.Modify.prototype.setNewCurrentChildren = function(obj){

  var currentLevel = this.getCurrentLevelObject();

  var index = currentLevel.children.indexOf(obj);

  if (index == -1) return;

  this.changeCurrentChildrenIndex(index);

};

G.Modify.prototype.childPropChange = function(currentLevel) {

  var orgLevel = this.currentLevel;
  var orgIndex = this.currentChildIndex;

  this.currentLevel = currentLevel || [];

  var currentLevelTxt = this.currentLevel.join('/') || (this.currentLevel[0] || game.state.current);

  var removeStr = this.removeCashObjToString(currentLevelTxt);

  var exportStr = '';

  var childrenPropNames = this.getChildrenPropNames();

  for (var i = 0; i < childrenPropNames.length; i++) {
    this.currentChildIndex = i;
    var obj = this.getCurrentObject();

    if (obj === this) continue;

    var currentChildPropTxt = childrenPropNames[i].toString();

    var fresh = obj.___NEWOBJECT;
    var isText = obj.constructor === G.OneLineText || obj.constructor === G.MultiLineText;

    if (fresh) {
      exportStr += 'NEW OBJECT \n';
      /*if (obj.___IMAGE) {
        exportStr += this.generateImageCode(currentChildPropTxt,obj);
      }*/
    }

    if (obj.___initState) {

      exportStr += '\t'+childrenPropNames[i]+'\n';

      var keys = Object.keys(obj.___initState);

      keys.forEach(function(key){
        exportStr += '\t'+key+':  '+G.StorageUtils.getObjProp(obj,key)+'\n';
      },this);

      obj.___initState = undefined;

    }

    if (!isText && (fresh || obj.children && obj.children.length > 0)) {
      this.childPropChange(this.currentLevel.concat(childrenPropNames[i]));
    }


  };

  if (exportStr.length > 0 || removeStr.length > 0) {

    if (removeStr.length > 0) removeStr+'\n'
    if (exportStr.length > 0) exportStr+'\n'
    this.export += currentLevelTxt+'\n'+removeStr+exportStr;

  }

  this.currentChildIndex = orgIndex;
  this.currentLevel = orgLevel;

};

G.Modify.prototype.exportChanges = function() {

  this.export = '';;
  this.childPropChange();

  if (this.export) {

    this.export = this.objectName+'\n'+this.export;
    G.Utils.copyToClipboard(this.export);
    console.log(this.export);
  }else{
    console.log('NO CHANGES TO EXPORT');
  }

};

G.Modify.prototype.processClick = function(){

  var pointer = game.input.activePointer;

  if (this.keys.M.isDown) {

    this.moveCurrentObjectToWorldPos(pointer.x,pointer.y);

  }

};


G.Modify.prototype.moveCurrentObjectToWorldPos = function(x,y){

    var obj = this.getCurrentObject();
    if (!obj) return;

    obj.updateTransform();

    var offsetX = x - obj.worldPosition.x;
    var offsetY = y - obj.worldPosition.y;

    var offset = new Phaser.Point(offsetX,offsetY);
    var pointer = new Phaser.Point(x,y);
    offset.normalize();

    var dist = obj.worldPosition.distance(pointer);

    while (true){

      var prev = dist;

      obj.x += offset.x;
      obj.y += offset.y;
      obj.updateTransform();

      var dist = obj.worldPosition.distance(pointer);

      if (dist > prev) break;

    }

    obj.x = Math.round(obj.x);
    obj.y = Math.round(obj.y);

};


G.Modify.prototype.addMouseWheel = function(){

  function mouseWheel(event) {

    var lvlObj = this.getCurrentLevelObject();
    if (lvlObj && lvlObj !== game.world) {
      lvlObj.y += game.input.mouse.wheelDelta * 150;
    }

  }

  game.input.mouse.mouseWheelCallback = mouseWheel.bind(this);

};


G.Modify.prototype.exportLvlAsString = function(){

  var exportObj = [];

  var lvl = this.getCurrentLevelObject();

  for (var i = 0; i < lvl.children.length; i++) {

    var child = lvl.children[i];

    if (!(child instanceof Phaser.Image)) continue;

    var frameName = null;
    if (typeof child.frameName === 'string') {
      if (child.frameName.indexOf('/') == -1) {
        frameName = child.frameName;
      }else {
        frameName = child.key;
      }
    }


    var childObj = {
      x: child.x,
      y: child.y,
      frame: frameName,
      anchor: [child.anchor.x,child.anchor.y],
      scale: [child.scale.x,child.scale.y],
      angle: child.angle
    };

    if (child.___LABEL) {
      childObj.label = child.___LABEL;
    }

    if (child.___DATA) {
      childObj.data = child.___DATA;
    }

    exportObj.push(childObj);

  };

  console.log(JSON.stringify(exportObj));

  G.Utils.copyToClipboard(JSON.stringify(exportObj));

};

G.Modify.prototype.objToTop = function(){

  var obj = this.getCurrentObject();
  if (!obj) return;
  var lvl = this.getCurrentLevelObject();
  lvl.bringToTop(obj);
  this.refreshLevel();
  this.setNewCurrentChildren(obj);

};

G.Modify.prototype.objMoveUp = function(){

  var obj = this.getCurrentObject();
  if (!obj) return;
  var lvl = this.getCurrentLevelObject();
  lvl.moveUp(obj);
  this.refreshLevel();
  this.setNewCurrentChildren(obj);

};

G.Modify.prototype.objMoveDown = function(){

  var obj = this.getCurrentObject();
  if (!obj) return;
  var lvl = this.getCurrentLevelObject();
  lvl.moveDown(obj);
  this.refreshLevel();
  this.setNewCurrentChildren(obj);

};

G.Modify.prototype.objToBottom = function(){

  var obj = this.getCurrentObject();
  if (!obj) return;
  var lvl = this.getCurrentLevelObject();
  lvl.sendToBack(obj);
  this.refreshLevel();
  this.setNewCurrentChildren(obj);

};
G.ModifyAnimationEditor = function(modify){

  Phaser.Group.call(this,game);

  this.modify = G.Modify.instance;

  this.tl = new G.ModifyAnimationTL();
  this.tl.x = 100;
  this.add(this.tl);

  this.fw = new G.ModifyAnimationFrameWindow();
  this.fw.x = -250;
  this.add(this.fw);

  this.tl.onFrameSelected.add(this.fw.refresh,this.fw);

  this.fw.onChange.add(function(obj,frameNr){
    console.log('fw onchange');
    this.tl.redrawTl();
    obj.updateAnimation(frameNr);
  },this);
  this.tl.changeTlPxWidth(800);

  this.visible = false;

  this.modify.onLevelObjChange.add(function(){

    var obj = this.modify.getCurrentLevelObject();

    if (obj.ANIMATIONELEMENT){
      this.open(obj);
    }else{
      this.close();
    }

  },this);

};

G.ModifyAnimationEditor.prototype = Object.create(Phaser.Group.prototype);

G.ModifyAnimationEditor.prototype.open = function(o){
  this.visible = true;
  this.tl.open(o);
  this.fw.refresh(o,0);

};

G.ModifyAnimationEditor.prototype.close = function(){

  this.visible = false;

}
G.ModifyAnimationFrameGroup = function(x,y){

  Phaser.Group.call(this,game);

  this.x = x;
  this.y = y;

  this.active = false;

  this.currentObj = null;
  this.currentKeyFrame = null;
  this.currentFrameNr = 0;

  this.style = {
    font: 'Verdana',
    fontSize: 13,
    fontWeight: 'bold'
  };

  this.onOffBtn = game.add.text(0,0,'off',this.style);
  this.onOffBtn.inputEnabled = true;
  this.onOffBtn.hitArea = new Phaser.Rectangle(0,0,this.onOffBtn.width,this.onOffBtn.height);
  this.onOffBtn.events.onInputDown.add(this.onOff,this);

  this.propValue = game.add.text(280,0,'---',this.style);
  this.propValue.anchor.x = 1;

  this.addMultiple([this.onOffBtn,this.propValue]);

  this.onChange = new Phaser.Signal();

};

G.ModifyAnimationFrameGroup.prototype = Object.create(Phaser.Group.prototype);

G.ModifyAnimationFrameGroup.prototype.onOff = function(){

    if (this.currentFrameNr == 0) return;

    if (this.active){

      this.active = false;
      this.alpha = 0.5;
      this.onOffBtn.setText('off');

      var index = this.currentObj.frameTL.indexOf(this.currentKeyFrame);
      this.currentObj.frameTL.splice(index,1);

    }else{

      this.active = true;
      this.alpha = 1;
      this.onOffBtn.setText('on');

      var newKeyFrame = {
        f: this.currentFrameNr,
        v: G.StorageUtils.getObjProp(this.currentObj.SPR,'frameName')
      };

      var f = this.currentFrameNr;
      var timeline = this.currentObj.frameTL;

      var indexToPut = 0;
      for (var i = 0; i < timeline.length; i++){
        if (timeline[i].f < f){
          indexToPut++;
        }
      }


      timeline.splice(indexToPut,0,newKeyFrame);

    }

    this.refresh(this.currentObj,this.currentFrameNr);
    //this.onChange.dispatch(this.currentObj,this.frameNr);

};

G.ModifyAnimationFrameGroup.prototype.update = function(){

  if (this.currentObj.playing){
    this.refresh(this.currentObj,this.currentObj.frameCounter);
    return;
  }


  if (this.currentObj){
    var val = (
      G.StorageUtils.getObjProp(this.currentObj.SPR,'frameName') ||
      G.StorageUtils.getObjProp(this.currentObj.SPR,'key')
    );

    if (val.indexOf('/')){
      val = val.slice(val.lastIndexOf('/')+1);
      //*val = val.slice(val.lastIndexOf('.'));
    }

    //show unsaved changes
    if (this.currentKeyFrame == null){
      if ( val != this.valAtRefresh){
        this.propValue.fill = 'red';
        this.alpha = 1;
      }else{
        this.alpha = 0.5;
        this.propValue.fill = 'black';
      }
    }

    if (!this.currentObj.playing
      && this.currentKeyFrame && this.currentKeyFrame.v !== val){
      this.currentKeyFrame.v = val;
    }

    this.propValue.setText(val);

  }else{
    this.propValue.setText('---');
  }

};



G.ModifyAnimationFrameGroup.prototype.refresh = function(obj,frameNr){

  this.currentObj = obj;

  if (!this.currentObj.currentAnimationName) return;


  this.currentKeyFrame = obj.getKeyFrameAt(obj.frameTL,frameNr);
  this.currentFrameNr = frameNr;

  this.propValue.fill = 'black';

  this.valAtRefresh = G.StorageUtils.getObjProp(this.currentObj.SPR,'frameName');

  if (this.currentKeyFrame){
    this.active = true;
    this.alpha = 1;

    this.onOffBtn.setText('on');

    console.log('frameGroup refresh');
    console.log(this.currentObj.getTextureFrameValue(obj.frameTL,frameNr));

    this.propValue.setText(this.currentObj.getTextureFrameValue(obj.frameTL,frameNr) || '---');

  }else {
    this.onOffBtn.setText('off');
    this.active = false;
    this.alpha = 0.5;
    this.propValue.setText('---');
  }

};
G.ModifyAnimationFrameWindow = function(){

  Phaser.Group.call(this,game);

  this.onChange = new Phaser.Signal();

  this.gfx =  game.add.graphics();
  this.gfx.inputEnabled = true;
  this.add(this.gfx);

  this.gfx.beginFill(0xdddddd);
  this.gfx.drawRect(0,0,300,500);

  this.style = {
    font: 'Verdana',
    fontSize: 13,
    fontWeight: 'bold'
  };

  this.currentAnimationTxt = game.add.text(10,10,'',this.style);
  this.add(this.currentAnimationTxt);
  this.currentAnimationTxt.inputEnabled = true;
  this.currentAnimationTxt.events.onInputDown.add(function(){
    this.changeAnimation();
  },this);

  this.addAnimationBtn = game.add.text(170,10,'+',this.style);
  this.add(this.addAnimationBtn);
  this.addAnimationBtn.inputEnabled = true;
  this.addAnimationBtn.events.onInputDown.add(this.addNewAnimation,this);

  this.renameAnimationBtn = game.add.text(200,10,'R',this.style);
  this.add(this.renameAnimationBtn);
  this.renameAnimationBtn.inputEnabled = true;
  this.renameAnimationBtn.events.onInputDown.add(this.renameAnimation,this);

  this.removeAnimationBtn = game.add.text(230,10,'-',this.style);
  this.add(this.removeAnimationBtn);
  this.removeAnimationBtn.inputEnabled = true;
  this.removeAnimationBtn.events.onInputDown.add(this.removeAnimation,this);

  this.frameNr = game.add.text(290,10,'',this.style);
  this.frameNr.anchor.x = 1;
  this.add(this.frameNr);

  this.frameGroup = new G.ModifyAnimationFrameGroup(10,50);
  this.add(this.frameGroup);

  this.propGroups = [
    new G.ModifyAnimationPropGroup(10,70,'alpha','#43c9e7'),
    new G.ModifyAnimationPropGroup(10,90,'x','#e08040'),
    new G.ModifyAnimationPropGroup(10,110,'y','#d8ff30'),
    new G.ModifyAnimationPropGroup(10,130,'angle','#072ba0'),
    new G.ModifyAnimationPropGroup(10,150,'scale.x','#6c0674'),
    new G.ModifyAnimationPropGroup(10,170,'scale.y','#d34ed9'),
    new G.ModifyAnimationPropGroup(10,190,'anchor.x'),
    new G.ModifyAnimationPropGroup(10,210,'anchor.y')
  ]

  this.propGroups.forEach(function(pg){
    pg.onChange.add(this.onChange.dispatch,this.onChange);
  },this);

  this.addMultiple(this.propGroups);

};

G.ModifyAnimationFrameWindow.prototype = Object.create(Phaser.Group.prototype);

G.ModifyAnimationFrameWindow.prototype.update = function(){

  if (!this.currentObj) return;

  this.propGroups.forEach(function(g){
    g.update();
  },this);

  this.frameGroup.update();

};

G.ModifyAnimationFrameWindow.prototype.loadFrame = function(obj,frameNr){

  this.currentObj = obj;
  this.labelObjTxt.setText(obj.LABEL || 'obj');
  this.frameNr.setText(frameNr);

};

G.ModifyAnimationFrameWindow.prototype.refresh = function(obj,frameNr){

  this.propGroups.forEach(function(pg){
    pg.refresh(obj,frameNr);
  });

  this.frameGroup.refresh(obj,frameNr);

  this.frameNr.setText(frameNr);

  this.currentFrameNr = frameNr;
  this.currentObj = obj;

  this.currentAnimationTxt.setText(this.currentObj.currentAnimationName || '------');

};

G.ModifyAnimationFrameWindow.prototype.changeAnimation = function(name){

  if (!this.currentObj) return;

  var animations = Object.keys(this.currentObj.dataAnimation);
  console.log(JSON.stringify(animations));

  if (name){

    this.currentObj.changeAnimationData(name);

  }else{

    if (this.currentObj.currentAnimationName){
      var index = animations.indexOf(this.currentObj.currentAnimationName);
      var newIndex = (index+1)%animations.length;
      console.log(index,newIndex);
      this.currentObj.changeAnimationData(animations[newIndex]);
    }else{
      this.currentObj.changeAnimationData(animations[0]);
    }

  }

  this.refresh(this.currentObj,this.currentFrameNr);
  this.onChange.dispatch(this.currentObj,0);

};

G.ModifyAnimationFrameWindow.prototype.addNewAnimation = function(){

  if (!this.currentObj) return;

  var animations = Object.keys(this.currentObj.dataAnimation);

  var name = 'newAnimation';
  var number = 0;

  while(animations.indexOf(name+number) !== -1){
    number++;
  }

  this.currentObj.dataAnimation[name+number] = {
    eventTL: [],
    frameTL: [{f:0, v:null}],
    propTLS: {
      alpha: [{f:0,v:1}],
      x: [{f:0,v:0}],
      y: [{f:0,v:0}],
      angle: [{f:0,v:0}],
      'scale.x': [{f:0,v:1}],
      'scale.y': [{f:0,v:1}],
      'anchor.x':  [{f:0,v:0.5}],
      'anchor.y':  [{f:0,v:0.5}]
    }
  }

  this.changeAnimation(name+number);

};

G.ModifyAnimationFrameWindow.prototype.removeAnimation = function(){

  if (!this.currentObj) return;
  if (!this.currentObj.currentAnimationName) return;

  if (Object.keys(this.currentObj.dataAnimation).length == 1) return;

  if (confirm('delete '+this.currentObj.currentAnimationName+'?')){
    delete this.currentObj.dataAnimation[this.currentObj.currentAnimationName];
    this.changeAnimation();
  }

};

G.ModifyAnimationFrameWindow.prototype.renameAnimation = function(){

  if (!this.currentObj) return;
  if (!this.currentObj.currentAnimationName) return;

  G.Modify.instance.domLayer.openInputDiv(
    this.currentObj.currentAnimationName,
    this.currentObj.currentAnimationName,
    function(value){
      var oldName = this.currentObj.currentAnimationName;
      var dataAnimation = this.currentObj.currentAnimationData;

      delete this.currentObj.dataAnimation[oldName];

      this.currentObj.dataAnimation[value] = dataAnimation;
      this.changeAnimation(value);

    },
    this,
    'string'
  );

};
G.ModifyAnimationPropGroup = function(x,y,prop,color){

  Phaser.Group.call(this,game);

  this.x = x;
  this.y = y;

  this.propKey = prop;
  this.active = false;

  this.currentObj = null;
  this.currentKeyFrame = null;
  this.currentFrameNr = 0;

  this.style = {
    font: 'Verdana',
    fontSize: 13,
    fontWeight: 'bold'
  };

  this.easings = [
    'Back','Bounce','Circular','Cubic','Elastic','Exponential','Linear','Quadratic','Quartic','Quintic','Sinusoidal'
  ];


  this.onOffBtn = game.add.text(0,0,'off',this.style);
  this.onOffBtn.inputEnabled = true;
  this.onOffBtn.hitArea = new Phaser.Rectangle(0,0,this.onOffBtn.width,this.onOffBtn.height);
  this.onOffBtn.events.onInputDown.add(this.onOff,this);

  this.label = game.add.text(30,0,prop,this.style);
  if (color) this.label.addColor(color,0);

  this.easingLabel0 = game.add.text(120,0,'',this.style);
  this.easingLabel0.inputEnabled = true;
  this.easingLabel0.hitArea = new Phaser.Rectangle(0,0,80,this.easingLabel0.height);
  this.easingLabel0.events.onInputDown.add(this.changeEasing0,this);

  this.easingLabel1 = game.add.text(200,0,'',this.style);
  this.easingLabel1.inputEnabled = true;
  this.easingLabel1.hitArea = new Phaser.Rectangle(0,0,50,this.easingLabel1.height);
  this.easingLabel1.events.onInputDown.add(this.changeEasing1,this);

  this.propValue = game.add.text(280,0,'',this.style);
  this.propValue.anchor.x = 1;

  this.addMultiple([this.label,this.onOffBtn,this.easingLabel0,this.easingLabel1,this.propValue]);

  this.onChange = new Phaser.Signal();

};

G.ModifyAnimationPropGroup.prototype = Object.create(Phaser.Group.prototype);

G.ModifyAnimationPropGroup.prototype.onOff = function(){

    if (this.currentFrameNr == 0) return;

    if (this.active){

      this.active = false;
      this.alpha = 0.5;
      this.onOffBtn.setText('off');

      var index = this.currentObj.propTLS[this.propKey].indexOf(this.currentKeyFrame);
      this.currentObj.propTLS[this.propKey].splice(index,1);

    }else{

      this.active = true;
      this.alpha = 1;
      this.onOffBtn.setText('on');

      var newKeyFrame = {
        f: this.currentFrameNr,
        v: G.StorageUtils.getObjProp(this.currentObj.SPR,this.propKey)
      };

      var f = this.currentFrameNr;
      var timeline = this.currentObj.propTLS[this.propKey];

      var indexToPut = 0;
      for (var i = 0; i < timeline.length; i++){
        if (timeline[i].f < f){
          indexToPut++;
        }
      }

      timeline.splice(indexToPut,0,newKeyFrame);

    }

    this.refresh(this.currentObj,this.currentFrameNr);
    //this.onChange.dispatch(this.currentObj,this.frameNr);

};

G.ModifyAnimationPropGroup.prototype.update = function(){

  if (this.currentObj.playing){
    this.refresh(this.currentObj,this.currentObj.frameCounter);
    return;
  }


  if (this.currentObj){
    var val = G.StorageUtils.getObjProp(this.currentObj.SPR,this.propKey);

    //show unsaved changes
    if (this.currentKeyFrame == null){
      if ( val != this.valAtRefresh){
        this.propValue.fill = 'red';
        this.alpha = 1;
      }else{
        this.alpha = 0.5;
        this.propValue.fill = 'black';
      }
    }

    if (!this.currentObj.playing
      //&& this.currentObj.frameCounter == this.currentFrameNr
      && this.currentKeyFrame && this.currentKeyFrame.v !== val){
      this.currentKeyFrame.v = val;
    }

    this.propValue.setText(val.toFixed(1));

  }else{
    this.propValue.setText('---');
  }

};

G.ModifyAnimationPropGroup.prototype.changeEasing0 = function(){

  if (!this.currentKeyFrame) return;

  if (this.currentKeyFrame.e){
    var index = this.easings.indexOf(this.currentKeyFrame.e[0]);

    if (index+1 == this.easings.length){
      this.currentKeyFrame.e = false;
      this.easingLabel0.setText('--');
      this.easingLabel1.setText('--');
    }else{
      this.currentKeyFrame.e[0] = this.easings[index+1];
      this.easingLabel0.setText(this.easings[index+1]);

      var currentE1 = this.currentKeyFrame.e[1];

      if (!Phaser.Easing[this.easings[index+1]][currentE1]){
        if (Phaser.Easing[this.easings[index+1]]['None']){
          this.currentKeyFrame.e[1] = 'None';
        }else if (Phaser.Easing[this.easings[index+1]]['In']){
          this.currentKeyFrame.e[1] = 'In';
        }
      }

      this.easingLabel1.setText(this.currentKeyFrame.e[1]);

    }

  }else {

    this.currentKeyFrame.e = ['Back','In'];
    this.easingLabel0.setText('Back');
    this.easingLabel1.setText('In');

  }

  this.onChange.dispatch(this.currentObj,this.currentFrameNr);

};

G.ModifyAnimationPropGroup.prototype.changeEasing1 = function(){

  if (!this.currentKeyFrame) return;
  if (!this.currentKeyFrame.e) return;

  var currentE1 = this.currentKeyFrame.e[1];
  var keys = Object.keys(Phaser.Easing[this.currentKeyFrame.e[0]]);

  var index = keys.indexOf(currentE1);

  this.currentKeyFrame.e[1] = keys[(index+1)%keys.length];
  this.easingLabel1.setText(this.currentKeyFrame.e[1]);

  this.onChange.dispatch(this.currentObj,this.currentFrameNr);

};



G.ModifyAnimationPropGroup.prototype.refresh = function(obj,frameNr){

  this.currentObj = obj;

  if (!this.currentObj.currentAnimationName) return;


  this.currentKeyFrame = obj.getKeyFrameAt(obj.propTLS[this.propKey],frameNr);
  this.currentFrameNr = frameNr;

  this.propValue.fill = 'black';

  this.valAtRefresh = G.StorageUtils.getObjProp(this.currentObj.SPR,this.propKey);

  if (this.currentKeyFrame){
    this.active = true;
    this.alpha = 1;

    this.onOffBtn.setText('on');

    if (this.currentKeyFrame.e){
      this.easingLabel0.setText(this.currentKeyFrame.e[0]);
      this.easingLabel1.setText(this.currentKeyFrame.e[1]);
    }else{
      this.easingLabel0.setText('---');
      this.easingLabel1.setText('---');
    }

  }else {
    this.onOffBtn.setText('off');
    this.active = false;
    this.alpha = 0.5;
    this.easingLabel0.setText('---');
    this.easingLabel1.setText('---');
  }

};
G.ModifyAnimationTL = function(){

  Phaser.Group.call(this,game);

  this.gfx = game.add.graphics();
  this.add(this.gfx);

  this.tlGfx = game.add.graphics();
  this.tlGfx.inputEnabled = true;

  this.pointerPressed = false;
  this.pointerStartFrame = 0;
  this.tlGfx.events.onInputDown.add(this.onDown,this);
  this.tlGfx.events.onInputUp.add(this.onUp,this);

  this.add(this.tlGfx);

  this.visible = false;
  this.currentObj = null;

  this.frameWidth = 10;
  this.frameHeight = 50;
  this.tlPxWidth = 400;
  this.tlFrameLength = this.tlPxWidth/this.frameWidth;

  this.selectedFrame = null;


  this.frameOffset = 0;

  this.cursors = game.input.keyboard.createCursorKeys();

  this.cursors.left.onDown.add(function(){
    this.frameOffset--;
    this.redrawTl();
  },this);

  this.cursors.right.onDown.add(function(){
    this.frameOffset++;
    this.redrawTl();
  },this);

  this.onFrameSelected = new Phaser.Signal();


};

G.ModifyAnimationTL.prototype = Object.create(Phaser.Group.prototype);

G.ModifyAnimationTL.prototype.colors = [0x972234,0x008b50,0x43c9e7,0xe08040,0xd8ff30,0x072ba0,0x6c0674,0xd34ed9];

G.ModifyAnimationTL.prototype.update = function(){

  if (this.pointerPressed){
    var p = game.input.activePointer;
    var frameNr = Math.floor((p.x - this.tlGfx.worldPosition.x)/this.frameWidth);
    if (frameNr !== this.pointerStartFrame){
      var diff = this.pointerStartFrame-frameNr;
      this.frameOffset += diff;
      this.pointerStartFrame = frameNr;
      this.frameOffset = Math.max(0,this.frameOffset);
      this.redrawTl();

    }
  }


};


G.ModifyAnimationTL.prototype.changeFrameWidth = function(newWidth){
  this.frameWidth = newWidth;
  this.tlFrameLength = Math.floor(this.tlPxWidth/this.frameWidth);
  this.redrawTl();
};

G.ModifyAnimationTL.prototype.changeTlPxWidth = function(newWidth){
  this.tlPxWidth = newWidth;
  this.tlFrameLength = Math.floor(this.tlPxWidth/this.frameWidth);
  this.redrawTl();
};

G.ModifyAnimationTL.prototype.open = function(obj){

  this.currentObj = obj;
  this.visible = true;
  this.redrawTl();
  this.currentObj.stop();

};

G.ModifyAnimationTL.prototype.onDown = function(obj,p){

  this.currentObj.pause();
  var frameNr = Math.floor((p.x - this.tlGfx.worldPosition.x)/this.frameWidth);
  this.pointerStartFrame = frameNr;
  this.pointerPressed = true;
};

G.ModifyAnimationTL.prototype.onUp = function(obj,p){

  var frameNr = Math.floor((p.x - this.tlGfx.worldPosition.x)/this.frameWidth);
  if (this.pointerStartFrame == frameNr){
    this.selectFrame(frameNr);
    this.pointerStar
  }
  this.pointerPressed = false;

};

G.ModifyAnimationTL.prototype.selectFrame = function(frameNr){

  this.selectedFrame = frameNr+this.frameOffset;
  this.currentObj.updateAnimation(this.selectedFrame);
  this.redrawTl();
  this.onFrameSelected.dispatch(this.currentObj,this.selectedFrame);

};

G.ModifyAnimationTL.prototype.redrawTl = function(){

  this.tlGfx.clear();

  if (!this.currentObj) return;
  if (!this.currentObj.currentAnimationName) return;

  this.tlGfx.beginFill(0xdddddd,1);
  this.tlGfx.drawRect(0,0,this.tlFrameLength*this.frameWidth,this.frameHeight);

  this.tlGfx.beginFill(0x999999,1);



  for (var i = this.frameOffset; i < this.frameOffset+this.tlFrameLength; i++){

    if (this.currentObj.isAnyKeyFrameAt(i)){
      this.tlGfx.lineStyle(1,0x000000,1);
      this.tlGfx.drawRect(this.frameWidth*i-(this.frameOffset*this.frameWidth),0,this.frameWidth,this.frameHeight);
    }

    if (i % 60 == 0){
      this.tlGfx.lineStyle(1,0x000000,0.25);
      this.tlGfx.moveTo(this.frameWidth*i-(this.frameOffset*this.frameWidth),0);
      this.tlGfx.lineTo(this.frameWidth*i-(this.frameOffset*this.frameWidth),this.frameHeight);
    }
  }



  this.tlGfx.lineStyle(0,0x000000,0);
  //event tl
  for (var i = 0; i < this.currentObj.eventTL.length; i++){
    var key = this.currentObj.eventTL[i];
    this.tlGfx.beginFill(this.colors[0],1);
    if (key.f >= this.frameOffset && key.f < this.frameOffset+this.tlFrameLength){
      this.tlGfx.drawRect(this.frameWidth*key.f-(this.frameOffset*this.frameWidth),0,this.frameWidth,5);
    }
  };

  for (var i = 0; i < this.currentObj.frameTL.length; i++){
    var key = this.currentObj.frameTL[i];
    this.tlGfx.beginFill(this.colors[1],1);
    if (key.f >= this.frameOffset && key.f < this.frameOffset+this.tlFrameLength){
      this.tlGfx.drawRect(this.frameWidth*key.f-(this.frameOffset*this.frameWidth),5,this.frameWidth,5);
    }
  }

  for (var i = 0; i < this.currentObj.propKeys.length; i++){
    this.drawPropLine(this.currentObj.propTLS[this.currentObj.propKeys[i]],15+i*5,this.colors[2+i]);
  }

  if (this.selectedFrame !== null && this.selectedFrame >= this.frameOffset && this.selectedFrame < this.frameOffset+this.tlFrameLength){
    this.tlGfx.beginFill(0x0000ff,0.5);
    this.tlGfx.drawRect(this.frameWidth*this.selectedFrame-(this.frameOffset*this.frameWidth),0,this.frameWidth,this.frameHeight);
  }

};

G.ModifyAnimationTL.prototype.drawPropLine = function(tl, y, color){

  var x;
  var w = this.frameWidth*0.5;

  for (var i = 0; i < tl.length; i++){
    var kf = tl[i];


    x = (kf.f*this.frameWidth+(this.frameWidth*0.5))-(this.frameOffset*this.frameWidth);

    this.tlGfx.lineStyle(0,0,0);

    if (kf.f < this.frameOffset) continue;


    //check if there was easing in prev key

    var pkf = tl[i-1];
    if (pkf && pkf.e){
      this.tlGfx.lineStyle(2,color,1);
      this.tlGfx.moveTo(0,y);
      this.tlGfx.lineTo(
        Math.min(
          this.tlFrameLength*this.frameWidth,
          kf.f*this.frameWidth-(this.frameOffset*this.frameWidth)
        ),y);
    };

    if (kf.f >= this.frameOffset+this.tlFrameLength) continue;

    if (kf.e){
      this.tlGfx.beginFill(color,1);
      this.tlGfx.drawCircle(x,y,w);

      if (tl[i+1]){
        this.tlGfx.lineStyle(2,color,1);
        this.tlGfx.moveTo(x,y);
        var lineToX = tl[i+1].f*this.frameWidth-(this.frameOffset*this.frameWidth);
        lineToX = Math.min(this.tlFrameLength*this.frameWidth,lineToX);
        this.tlGfx.lineTo(lineToX,y);
      }

    }else{
      this.tlGfx.endFill();
      this.tlGfx.lineStyle(2,color,1);
      this.tlGfx.drawCircle(x,y,w-2);
    }

  }

};
G.ModifyBottomBar = function(){

  Phaser.Group.call(this,game);

  this.modify = G.Modify.instance;

  this.gfx = game.add.graphics();

  this.gfx.beginFill(0xcccccc,1);
  this.gfx.drawRect(0,0,3000,30);
  this.gfx.inputEnabled = true;
  this.gfx.events.onInputDown.add(function() {});
  this.add(this.gfx);

  var style = {
    font: 'Verdana',
    fontSize: 15,
    fontWeight: 'bold'
  }

  this.buttons = [
    G.Utils.makeTextButton(10,5,'+GROUP',this.modify.addGroup,this.modify,style),
    G.Utils.makeTextButton(90,5,'+IMG',this.modify.addImage,this.modify,style),
    G.Utils.makeTextButton(160,5,'+OneLine',this.modify.addOneLineText,this.modify,style),
    G.Utils.makeTextButton(260,5,'+MultiLine',this.modify.addMultiLineText,this.modify,style),
    G.Utils.makeTextButton(360,5,'+BTN',this.modify.addButton,this.modify,style),
    G.Utils.makeTextButton(450,5,'REMOVE',this.modify.removeObject,this.modify,style),
    G.Utils.makeTextButton(600,5,'EXPORT LVL STR',this.modify.exportLvlAsString,this.modify,style)
  ];

  this.addMultiple(this.buttons);


};

G.ModifyBottomBar.prototype = Object.create(Phaser.Group.prototype);
G.ModifyButtonGroup = function() {

    Phaser.Group.call(this, game);

    this.modify = G.Modify.instance;

    this.fixedToCamera = true;

    this.gfx = this.add(game.add.graphics());

    this.transformButtons = this.add(game.add.group());
    this.changeObjButtons = this.add(game.add.group());

    this.mode = 0;

    this.tabKey = game.input.keyboard.addKey(Phaser.Keyboard.TAB);
    this.tabKey.onDown.add(function() {
        this.gfx.clear();
        this.mode = (this.mode + 1) % 2;
        this.transformButtons.visible = this.mode == 0;
        this.changeObjButtons.visible = this.mode == 1;
    }, this);

    this.keys = {
        ALT: game.input.keyboard.addKey(Phaser.Keyboard.ALT)
    }



    this.clickedButton = null;
    this.clickedPos = null;



    this.posButton = game.add.button(0, 0, null);
    this.posButton.onInputDown.add(function() {
        this.clickedButton = this.posButton;
        this.clickedPos = { x: game.input.activePointer.x, y: game.input.activePointer.y };
    }, this);
    this.posButton.anchor.setTo(0.5, 0.5);
    this.posButton.tint = 0xff0000;
    this.transformButtons.add(this.posButton);

    this.scaleButton = game.add.button(0, 0, null);
    this.scaleButton.onInputDown.add(function() {
        this.clickedButton = this.scaleButton;
        this.clickedPos = { x: game.input.activePointer.x, y: game.input.activePointer.y };
    }, this);
    this.scaleButton.anchor.setTo(0.5, 0.5);
    this.scaleButton.tint = 0x00ff00;
    this.transformButtons.add(this.scaleButton);


    this.rotateButton = game.add.button(0, 0, null);
    this.rotateButton.onInputDown.add(function() {
        this.clickedButton = this.rotateButton;
        this.clickedPos = { x: game.input.activePointer.x, y: game.input.activePointer.y };
    }, this);
    this.rotateButton.anchor.setTo(0.5, 0.5);
    this.rotateButton.tint = 0x00ff00;
    this.transformButtons.add(this.rotateButton);

    this.refreshChangeObjButtons();

    this.modify.onLevelObjChange.add(this.refreshChangeObjButtons, this);
    this.modify.onObjDestroy.add(this.refreshChangeObjButtons, this);

};

G.ModifyButtonGroup.prototype = Object.create(Phaser.Group.prototype);

G.ModifyButtonGroup.prototype.update = function() {

    if (this.mode == 0) {
        this.updateTransformButtons();
      this.transformButtons.ignoreChildInput = false;
        this.changeObjButtons.ignoreChildInput = true;
    } else {
      this.transformButtons.ignoreChildInput = true;
        this.changeObjButtons.ignoreChildInput = false;
        this.updateChangeObjButtons();
    };

};

G.ModifyButtonGroup.prototype.updateTransformButtons = function() {

    var obj = this.modify.getCurrentObject();
    if (!obj) {
        this.posButton.position.setTo(-9999, -9999);
        this.scaleButton.position.setTo(-9999, -9999);
        this.rotateButton.position.setTo(-9999, -9999);
        return;
    };
    var bounds = obj.getBounds();
    var localBounds = obj.getLocalBounds();
    var pointer = game.input.activePointer

    this.posButton.x = obj.worldPosition.x;
    this.posButton.y = obj.worldPosition.y;

    this.scaleButton.x = obj.worldPosition.x + localBounds.x * obj.scale.x + bounds.width * obj.scale.x + 20,
        this.scaleButton.y = obj.worldPosition.y + localBounds.y * obj.scale.y + bounds.height * obj.scale.y + 20;

    this.rotateButton.x = obj.worldPosition.x + localBounds.x * obj.scale.x - 20;
    this.rotateButton.y = obj.worldPosition.y + localBounds.y * obj.scale.y - 20;



    this.gfx.clear();

    this.gfx.lineStyle(1, 0x000000, 1);
    this.gfx.beginFill(0xff0000, 1);
    this.gfx.drawCircle(this.posButton.worldPosition.x, this.posButton.worldPosition.y, 10);
    this.gfx.endFill();

    this.gfx.beginFill(0x00ff00, 1);
    this.gfx.drawCircle(this.scaleButton.worldPosition.x, this.scaleButton.worldPosition.y, 10);
    this.gfx.endFill();

    this.gfx.beginFill(0x0000ff, 1);
    this.gfx.drawCircle(this.rotateButton.worldPosition.x, this.rotateButton.worldPosition.y, 10);
    this.gfx.endFill();


    if (!this.clickedButton) return;

    if (pointer.isDown) {
        var offsetX = pointer.x - this.clickedPos.x;
        var offsetY = pointer.y - this.clickedPos.y;

        if (this.clickedButton === this.posButton) {
            this.modify.modifyCurrentObjProp('x', obj.x + offsetX);
            this.modify.modifyCurrentObjProp('y', obj.y + offsetY);
        }

        if (this.clickedButton === this.scaleButton) {
            this.modify.modifyCurrentObjProp('width', obj.width + offsetX);
            this.modify.modifyCurrentObjProp('height', obj.height + offsetY);
            if (this.keys.ALT.isDown) {
                //obj.scale.y = obj.scale.x;
                this.modify.modifyCurrentObjProp('scale.y', obj.scale.x);
            }
        }

        if (this.clickedButton === this.rotateButton) {
            this.modify.modifyCurrentObjProp('angle', obj.angle + offsetX * 0.25);
            //obj.angle += offsetX*0.25;

        }

        this.clickedPos = { x: game.input.activePointer.x, y: game.input.activePointer.y };
    } else {
        this.modify.modifyCurrentObjProp('x', Math.floor(obj.x / 5) * 5);
        this.modify.modifyCurrentObjProp('y', Math.floor(obj.y / 5) * 5);
        this.modify.modifyCurrentObjProp('scale.x', Math.floor(obj.scale.x / 0.025) * 0.025);
        this.modify.modifyCurrentObjProp('scale.y', Math.floor(obj.scale.y / 0.025) * 0.025);
        this.modify.modifyCurrentObjProp('angle', Math.floor(obj.angle));
        this.clickedButton = null;
    }



};

G.ModifyButtonGroup.prototype.updateChangeObjButtons = function() {

    this.gfx.clear();
    this.gfx.beginFill(0x00ff00, 1);
    this.gfx.lineStyle(3, 0xff0000, 1)

    for (var i = 0; i < this.changeObjButtons.length; i++) {
        var child = this.changeObjButtons.children[i];
        this.gfx.drawCircle(child.worldPosition.x, child.worldPosition.y, 10);
    }

};

G.ModifyButtonGroup.prototype.refreshChangeObjButtons = function() {

    this.changeObjButtons.removeAll(true);

    var currentLevel = this.modify.getCurrentLevelObject();

    for (var i = 0; i < currentLevel.children.length; i++) {

        if (currentLevel.children[i] == this.modify) continue;

        var child = currentLevel.children[i];
        var btn = game.make.button(0, 0, null);
        this.changeObjButtons.add(btn);
        btn.attachement = child;
        btn.modify = this.modify;
        btn.position = child.worldPosition;
        btn.hitArea = new Phaser.Circle(0, 0, 10);
        btn.onInputDown.add(function() {
            this.modify.setNewCurrentChildren(this.attachement);
        }, btn);

    }

};

G.ModifyChildList = function(){

  Phaser.Group.call(this,game);

  this.fixedToCamera = true;

  this.modify = G.Modify.instance;

  this.levelTxt = game.add.text(20,0,'',{
    font: 'Verdana',
    fontSize: 20
  });
  this.levelTxtBack = game.add.text(0,0,'<',{
    font: 'Verdana',
    backgroundColor: 'rgba(0,255,0,0.5)',
    fontSize: 20,
    fontWeight: 'bold'
  });
  this.levelTxtBack.visible = false;
  this.levelTxtBack.inputEnabled = true;
  this.levelTxtBack.input.useHandCursor = true;
  this.levelTxtBack.events.onInputDown.add(function() {
    this.modify.currentLevelGoUp();
  },this);
  this.add(this.levelTxtBack);
  this.add(this.levelTxt);

  this.listGroup = this.add(game.add.group());
  this.listGroup.y = 40;

  this.makeList();

  this.currentLevelObj = this.modify.getCurrentLevelObject();
  this.currentObj = this.modify.getCurrentObject();

  this.modify.onLevelObjChange.add(this.makeList,this);
  this.modify.onCurrentObjChange.add(this.refreshTexts,this);
  this.modify.onObjDestroy.add(this.makeList);

};

G.ModifyChildList.prototype = Object.create(Phaser.Group.prototype);


G.ModifyChildList.prototype.hideList = function(){

  this.listGroup.visible = false;

};

G.ModifyChildList.prototype.showList = function(){

  this.listGroup.visible = true;
};

G.ModifyChildList.prototype.makeList = function(){

  var obj = this.modify.getCurrentLevelObject();
  this.listGroup.removeAll();

  for (var i = 0; i < this.modify.childrenPropNames.length; i++) {

    var hasChildren = (obj.children[i].children && obj.children[i].children.length > 0) || obj.children[i].constructor === Phaser.Group;

    var isTextObj = obj.children[i].constructor == G.OneLineText || obj.children[i].constructor == G.MultiLineText;

    var childrenTxt = '';
    if (hasChildren) {
      childrenTxt = '(' + (G.countChildren(obj.children[i])-1) + ')';
    }

    var txt = game.make.text(0, i*20, this.modify.childrenPropNames[i].join('.') + childrenTxt,{
      font: 'Verdana',
      fontSize: 15,
      backgroundColor: 'rgba(221,221,221,0.5)',
      fontWeight: 'bold'
    });


    var self = this.modify.childrenPropNames[i].join('.') == 'G.MODIFY-EDITOR'

    if (!isTextObj && !self && hasChildren) {

      var levelText = game.make.text(txt.width+10,0,'+',{
        font: 'Verdana',
        fontSize: 15,
        backgroundColor: 'rgba(200,255,200,0.75)',
        fontWeight: 'bold'
      });
      txt.addChild(levelText);

      levelText.txtBtn = txt;
      levelText.modify = this.modify;
      levelText.childList = this;
      levelText.indexChild = i;
      levelText.inputEnabled = true;
      levelText.input.useHandCursor = true;
      levelText.hitArea = new Phaser.Rectangle(0,0,levelText.width,levelText.height);
      levelText.events.onInputDown.add(function() {
          this.modify.currentLevelGoDown(this.indexChild);
      },levelText);

    }

    this.listGroup.add(txt);

    if (!self) {

      txt.inputEnabled = true;
      txt.indexChild = i;
      txt.childList = this;
      txt.modify = this.modify;
      txt.hitArea = new Phaser.Rectangle(0,0,txt.width,txt.height);
      txt.input.useHandCursor = true;
      txt.events.onInputDown.add(function() {
        this.modify.changeCurrentChildrenIndex(this.indexChild);
      },txt);

    }
  }


  this.refreshTexts();

};


G.ModifyChildList.prototype.refreshTexts = function() {

  this.levelTxt.setText(this.modify.currentLevel.join('/') || (this.modify.currentLevel[0] || game.state.current));

  this.levelTxtBack.visible = this.levelTxt.text !== game.state.current;

  for (var i = 0; i < this.listGroup.length; i++) {

    var txt = this.listGroup.children[i];

    if (this.modify.currentChildIndex == i) {
      txt.x = 10;
      if (txt.style.backgroundColor === 'rgba(221,221,221,0.5)') {
        txt.style.backgroundColor = 'rgba(180,180,255,1)';
        txt.updateText();
      }

    }else {
      txt.x = 0;
      if (txt.style.backgroundColor === 'rgba(180,180,255,1)'){
        txt.style.backgroundColor = 'rgba(221,221,221,0.5)';
        txt.updateText();
      }
    }

  }

};

G.ModifyCodeGenerator = function(modify){

  this.modify = modify;

};


G.ModifyCodeGenerator.prototype.start = function(obj){

  this.constStr = '';
  var exeStr = this.generateCode(obj);

  var endStr = this.constStr+'\n\n'+exeStr;

  G.Utils.copyToClipboard(endStr);
  console.log(endStr);

};


G.ModifyCodeGenerator.prototype.generateCode = function(obj,prefix){

  if (G.OneLineText) {
    if (obj instanceof G.OneLineText) {
      return this.generateCodeOneLineText(obj,prefix);
    }
  }

  if (G.MultiLineText){
    if (obj instanceof G.MultiLineText) {
      return this.generateCodeMultiLineText(obj,prefix);
    }
  }

  if (G.Button){
    if (obj instanceof G.Button){
      return this.generateCodeButton(obj,prefix);
    }
  }

  if ((obj instanceof Phaser.Group) && !(obj instanceof Phaser.BitmapText)){
    if (obj.___CONSTRUCTOR) {
      return this.generateConstructorCode(obj,prefix);
    }else {
      return this.generateGroupCode(obj,prefix);
    }
  }


  return this.generateCodeImage(obj,prefix);

};

G.ModifyCodeGenerator.prototype.generateConstructorCode = function(obj,prefix,inside){

  var name = this.getObjName(obj);

  var capName = G.capitalize(name);

  var constStr = '';

  constStr += 'G.'+capName+' = function(x,y){\n';
  constStr += '\tPhaser.Group.call(this,game);\n';
  constStr += '\tthis.position.setTo(x,y);\n';
  constStr += this.generateCodeUniProp(obj,'this');
  constStr += '\n';

  for (var i = 0; i < obj.children.length; i++){
    constStr += '\t'+this.generateCode(obj.children[i],'this');
    constStr += '\n';
  }

  constStr += '};\n';
  constStr += 'G.'+capName+'.prototype = Object.create(Phaser.Group.prototype);\n\n';

  this.constStr += constStr;

  var exeStr = (prefix ? prefix+'.' : 'var ') +'%NAME% = new G.'+capName+'(^x^,^y^);\n';
  if (prefix) {
    exeStr += prefix+'.add('+prefix+'.%NAME%);\n';
  }
  exeStr = G.Utils.replaceAll(exeStr,'%NAME%',name);
  exeStr = this.injectObjPropToString(obj,exeStr);

  return exeStr;

};

G.ModifyCodeGenerator.prototype.generateGroupCode = function(obj,prefix) {

  var name = this.getObjName(obj);

  var str = (prefix ? prefix+'.' : 'var ') +'%NAME% = game.add.group();\n';
  str += (prefix ? prefix+'.' : '')+'%NAME%.position.setTo(^x^,^y^);\n';
  str += this.generateCodeUniProp(obj,prefix);

  if (prefix) {
    str += prefix+'.add('+prefix+'.%NAME%);\n';
  }

  for (var i = 0; i < obj.children.length; i++){
    var childStr = this.generateCode(obj.children[i],(prefix ? prefix+'.' : '')+name,true);
    str += G.Utils.replaceAll(childStr,'this','%NAME%');
  }

  str = G.Utils.replaceAll(str,'%NAME%',name);
  return this.injectObjPropToString(obj,str);
}

G.ModifyCodeGenerator.prototype.generateGroupConstructor = function(obj){



};

G.ModifyCodeGenerator.prototype.generateChildrensCode = function(obj){


};

G.ModifyCodeGenerator.prototype.generateCodeButton = function(obj,prefix){

  prefix = prefix || '';

  var str = '';
  str += (prefix ? prefix+'.' : 'var ') +"%NAME% = new G.Button(^x^,^y^,'^frameName^',function(){},this);\n";
  str += (prefix ? prefix+'.' : '')+'add('+(prefix ? prefix+'.' : 'var ')+'%NAME%);\n';
  str += this.generateCodeUniProp(obj,prefix);
  str = G.Utils.replaceAll(str,'%NAME%',this.getObjName(obj));
  return this.injectObjPropToString(obj,str);

};

G.ModifyCodeGenerator.prototype.generateCodeImage = function(obj,prefix){

  var str = '';
  str += (prefix ? prefix+'.' : 'var ') +"%NAME% = G.makeImage(^x^,^y^,'^frameName^',[^anchor.x^,^anchor.y^],"+prefix+");\n";
  str += this.generateCodeUniProp(obj,prefix);
  str = G.Utils.replaceAll(str,'%NAME%',this.getObjName(obj));
  return this.injectObjPropToString(obj,str);

};

G.ModifyCodeGenerator.prototype.generateCodeOneLineText = function(obj,prefix){

  var str = '';
  str += (prefix ? prefix+'.' : 'var ') + "%NAME% = new G.OneLineText(^x^,^y^,'^font^','^text^',^fontSize^,^maxUserWidth^,^anchor.x^,^anchor.y^);\n";
  str += (prefix ? prefix+'.' : '')+'add('+(prefix ? prefix+'.' : 'var ')+'%NAME%);\n';
  str += this.generateCodeUniProp(obj,prefix);
  str = G.Utils.replaceAll(str,'%NAME%',this.getObjName(obj));
  return this.injectObjPropToString(obj,str);

};

G.ModifyCodeGenerator.prototype.generateCodeMultiLineText = function(obj,prefix){

  var str = '';
  str +=  (prefix ? prefix+'.' : 'var ') + "%NAME% = new G.MultiLineText(^x^,^y^,'^font^','^text^',^fontSize^,^maxUserWidth^,^maxUserHeight^,'^align^',^anchor.x^,^anchor.y^);\n";
  str += (prefix ? prefix+'.' : '')+'add('+(prefix ? prefix+'.' : 'var ')+'%NAME%);\n';
  str += this.generateCodeUniProp(obj,prefix);
  str = G.Utils.replaceAll(str,'%NAME%',this.getObjName(obj));
  return this.injectObjPropToString(obj,str);

};


G.ModifyCodeGenerator.prototype.getObjName = function(obj){

  if (obj.___LABEL){
    return obj.___LABEL;
  }else{
    var name = prompt('enter name');
    obj.___LABEL = name;
    return name;
  }

};

G.ModifyCodeGenerator.prototype.generateCodeUniProp = function(obj,prefix){

  var str = '';
  prefix = prefix ? prefix+'.' : '';

  if (obj.scale.x !== 1 || obj.scale.y !== 1){
    str += prefix+'%NAME%.scale.setTo(^scale.x^, ^scale.y^);\n';
  }

  if (obj.angle !== 0){
    str += prefix+'%NAME%.angle = ^angle^;\n';
  }

  if (obj.alpha !== 1){
    str += prefix+'%NAME%.alpha = ^alpha^;\n';
  }

  if (obj.fixedToCamera){
    str += prefix+'%NAME%.fixedToCamera = true;\n';
    str += prefix+'%NAME%.cameraOffset.setTo(^cameraOffset.x^,^cameraOffset.y^);\n';
  }

  return str;

};


G.ModifyCodeGenerator.prototype.injectObjPropToString = function(obj,str){

  while (true){

    var firstIndex = str.indexOf('^');
    var secondIndex = str.indexOf('^',firstIndex+1);

    if (firstIndex == -1){
      break;
    }

    var toReplace = str.slice(firstIndex,secondIndex+1);
    var propToGet = str.slice(firstIndex+1,secondIndex);

    str = str.replace(toReplace,G.StorageUtils.getObjProp(obj,propToGet));


  };

  return str;

};
G.ModifyDOMLayer = function(modify){

  this.modify = modify;

  this.openElement = null;

  this.extraDataDiv = this.initExtraDataDiv();
  this.inputDataDiv = this.initInputDiv();

};

G.ModifyDOMLayer.prototype.closeCurrent = function(){

  game.time.events.add(1,function(){
    game.input.enabled = true;
  });
  this.openElement.style.display = 'none';
  game.canvas.focus();

};

G.ModifyDOMLayer.prototype.initExtraDataDiv = function(){

  var dataInputDiv = document.createElement('DIV');
  dataInputDiv.style.backgroundColor = 'green';
  dataInputDiv.style.left = '10%';
  dataInputDiv.style.top = '10%';
  dataInputDiv.style.position = 'fixed';
  dataInputDiv.style.width = '80%';
  dataInputDiv.style.height = '80%';

  var input = document.createElement('TEXTAREA');
  input.style.marginTop = '2%';
  input.style.marginLeft = '2%';
  input.style.width = '95%';
  input.style.height = '94%';
  input.style.resize = 'none';

  input.onkeydown = (function(e){

    var textarea = e.target;
    var div = dataInputDiv;

    //check if data is correct
      game.time.events.add(1, function(){
        try {
        eval('var tmp = '+textarea.value);
        if (typeof tmp === 'object'){
          div.style.backgroundColor = 'green';
          div.proper = true;
        }else {
          div.style.backgroundColor = 'red';
          div.proper = false;
        }
      }catch(e){
        div.style.backgroundColor = 'red';
        div.proper = false;
      }
      });


      if(e.keyCode==9 || e.which==9){
          e.preventDefault();
          var s = textarea.selectionStart;
          textarea.value = textarea.value.substring(0,textarea.selectionStart) + "\t" + textarea.value.substring(textarea.selectionEnd);
          textarea.selectionEnd = s+1;
      }

      if(e.keyCode == 83 && e.ctrlKey) {
        e.preventDefault();
        if (div.proper){
          this.closeCurrent();
          div.callback.call(div.context,textarea.value);
        }
        return false;

      }

      if (e.keyCode == 27) {
      this.closeCurrent();
      }

  }).bind(this);

  dataInputDiv.textarea = input;

  dataInputDiv.appendChild(input);
  document.body.appendChild(dataInputDiv);

  dataInputDiv.style.display = 'none';
  dataInputDiv.style.position = 'fixed';


  return dataInputDiv;

};

G.ModifyDOMLayer.prototype.openExtraData = function(label,data,callback,context){

  console.log('openExtraData');

  this.openElement = this.extraDataDiv;

  this.extraDataDiv.style.backgroundColor = 'green';
  this.extraDataDiv.callback = callback || function(){};
  this.extraDataDiv.context = context || this;

  this.extraDataDiv.style.display = 'block';
  game.input.enabled = false;

  if (data) {
    if (typeof data === 'object'){
      data = JSON.stringify(data,null,"\t");
    }
  }else {
    data = '';
  }

  this.extraDataDiv.textarea.value = data;

  game.time.events.add(1,function(){
    this.extraDataDiv.textarea.focus();
  },this);

};


G.ModifyDOMLayer.prototype.initInputDiv = function(){

  var inputDiv = document.createElement('DIV');
  inputDiv.style.backgroundColor = 'gray';
  inputDiv.style.left = '30%';
  inputDiv.style.top = '10%';
  inputDiv.style.position = 'fixed';
  inputDiv.style.width = '40%';
  inputDiv.style.textAlign = 'center';
  inputDiv.style.padding = '10px';
  inputDiv.style.fontFamily = 'Verdana';

  var span = document.createElement('h3');

  var filterLabel = document.createElement('SPAN');
  filterLabel.style.float = 'right';

  var initValue = document.createElement('SPAN');
  initValue.style.float = 'left';

  span.innerHTML = '';

  var input = document.createElement('INPUT');
  input.style.width = '90%';
  input.style.fontSize = '25px';

  input.onkeydown = (function(e){

    var textarea = e.target;
    var div = inputDiv;

      if((e.keyCode == 83 && e.ctrlKey) || (e.keyCode == 13)) {
        e.preventDefault();

        var filteredValue = div.filter(textarea.value);

        if (filteredValue === undefined){

          div.style.backgroundColor = 'red';
          game.time.events.add(50,function(){
            div.style.backgroundColor = 'gray';
          });


        }else{

          this.closeCurrent();
          div.callback.call(div.context,filteredValue);

        }
        return false;
      }

      if (e.keyCode == 27) {
      this.closeCurrent();
      }

  }).bind(this);

  inputDiv.appendChild(span);
  inputDiv.appendChild(input);
  inputDiv.appendChild(filterLabel);
  inputDiv.appendChild(initValue);
  document.body.appendChild(inputDiv);

  inputDiv.span = span;
  inputDiv.textarea = input;
  inputDiv.input = input;
  inputDiv.filterLabel = filterLabel;
  inputDiv.initValue = initValue;

  inputDiv.filters = {
    number: function(value){
      var parsed = parseFloat(value);
      if (isNaN(parsed)){
        return undefined;
      }else{
        return parsed;
      }
    },
    string: function(value){

      if (value.length == 0) return undefined;

      return value;
    },
    none: function(value){
      return value;
    }
  }

  inputDiv.style.display = 'none';
  inputDiv.style.position = 'fixed';

  return inputDiv;

};

G.ModifyDOMLayer.prototype.openInputDiv = function(label,initValue,callback,context,filter){

  if (!this.inputDataDiv){
    this.initInputArea();
  }

  this.openElement = this.inputDataDiv;

  this.inputDataDiv.style.display = 'block';
  game.input.enabled = false;

  this.inputDataDiv.span.innerHTML = label || '';

  this.inputDataDiv.input.value = initValue;

  this.inputDataDiv.callback = callback || function(){};
  this.inputDataDiv.context = context || this;

  filter = filter || 'none';
  this.inputDataDiv.filter = this.inputDataDiv.filters[filter];
  this.inputDataDiv.filterLabel.innerHTML = filter;

  this.inputDataDiv.initValue.innerHTML = 'init val: '+initValue;

  game.time.events.add(1,function(){
    this.inputDataDiv.input.focus();
    this.inputDataDiv.input.select();
  },this);

};


G.ModifyFrameSelector = function() {

  Phaser.Group.call(this,game);

  this.panelWidth = 300;

  this.gfx = game.make.graphics();
  this.add(this.gfx);
  this.gfx.beginFill(0xdddddd,1);
  this.gfx.drawRect(0,0,this.panelWidth,game.height);
  this.gfx.inputEnabled=true;
  this.gfx.events.onInputDown.add(function(){});
  this.framesBtns = [];
  this.framesGroup = this.add(game.add.group());
  this.framesGroup.y = 50;

  this.topGroup = this.add(this.createTopBar());
  this.bottomGroup = this.add(this.createBottomBar());

  this.opened = false;

  this.onFrameClicked = new Phaser.Signal();


};

G.ModifyFrameSelector.prototype = Object.create(Phaser.Group.prototype);

G.ModifyFrameSelector.prototype.open = function() {

  this.opened = true;

};

G.ModifyFrameSelector.prototype.close = function() {

  this.opened = false;

};

G.ModifyFrameSelector.prototype.update = function() {

  if (this.opened) {
    this.x = game.world.bounds.x+game.width-this.panelWidth;
  }else {
    this.x = game.world.bounds.x+game.width;
  }

  this.bottomGroup.y = game.world.bounds.y+game.height-this.bottomGroup.height;


};

G.ModifyFrameSelector.prototype.loadAtlas = function(atlasName) {

  var columnsNr = 5;
  var collWidth = this.panelWidth/columnsNr;

  this.framesGroup.removeAll();

  var arrayToIterate = atlasName == '__singleImages' ? this.__singleImages : game.cache.getFrameData(atlasName)._frames;


  for (var i = 0; i < arrayToIterate.length; i++) {

    var col = i % columnsNr;
    var row = Math.floor(i/columnsNr);
    var name = arrayToIterate[i].name

    this.createFrameButton(col*collWidth,row*collWidth,name,collWidth,atlasName ==  '__singleImages')

  }


};

G.ModifyFrameSelector.prototype.createBottomBar = function() {

  var bottomGroup = game.add.group();
  bottomGroup.gfx = game.add.graphics();
  bottomGroup.gfx.beginFill(0xcccccc,1);
  bottomGroup.gfx.drawRect(0,0,this.panelWidth,20);
  bottomGroup.gfx.inputEnabled = true;
  bottomGroup.gfx.events.onInputDown.add(function() {});
  bottomGroup.add(bottomGroup.gfx);

  var style = {
    font: 'Verdana',
    fontSize: 15,
    fontWeight: 'bold'
  }

  var buttons = [
    game.make.text(10, 2, 'UP', style),
    game.make.text(10+this.panelWidth*0.3, 2, 'DOWN',style),
    game.make.text(10+this.panelWidth*0.6, 2, 'CLOSE',style)
  ];

  buttons.forEach(function(b) {
    bottomGroup.add(b);
    b.inputEnabled = true;
    b.hitArea = new Phaser.Rectangle(0,0,b.width,b.height);
    b.input.useHandCursor = true;
  });

  buttons[0].events.onInputDown.add(function() {
    this.framesGroup.y += 300;
    this.framesGroup.y = Math.min(50,this.framesGroup.y);
    //this.framesGroup.y = Math.min(this.framesGroup.y,this.framesGroup.height-game.height);
  },this);

  buttons[1].events.onInputDown.add(function() {
    this.framesGroup.y -= 300;
    this.framesGroup.y = Math.min(this.framesGroup.y,-(this.framesGroup.height-game.height));
  },this);

  buttons[2].events.onInputDown.add(function() {
    this.opened = false;
  },this);

  return bottomGroup;

};

G.ModifyFrameSelector.prototype.createTopBar = function() {

  var topGroup = game.add.group();
  this.topGroup = topGroup;
  topGroup.gfx = game.add.graphics();
  topGroup.gfx.beginFill(0xcccccc,1);
  topGroup.gfx.drawRect(0,0,this.panelWidth,25);
  topGroup.gfx.inputEnabled = true;
  topGroup.gfx.events.onInputDown.add(function() {});
  topGroup.add(topGroup.gfx);

  var imgCache = game.cache._cache.image
  this.__singleImages = [];

  var i = 0;

  for (prop in imgCache) {

    if (prop[0] == '_' && prop[1] == '_') continue;

    //singleImg
    if (imgCache[prop].frame) {

      this.__singleImages.push({name:imgCache[prop].key});

    }else {

      this.createAtlasButton(5+(i*25),2,(i+1),prop);
      i++;

    }

  }

  this.createAtlasButton(5+(i*25)+10,2,'img','__singleImages');

  return topGroup;

};

G.ModifyFrameSelector.prototype.createAtlasButton = function(x,y,label,atlas) {

  var txt = game.make.text(x, y, label,{
    font: 'Verdana',
    fontSize: 15,
    fontWeight: 'bold'
  });

  this.topGroup.add(txt);
  txt.inputEnabled = true;
  txt.atlas = atlas;
  txt.hitArea = new Phaser.Rectangle(0,0,txt.width,txt.height);
  txt.input.useHandCursor = true;
  txt.frameSelector = this;
  txt.events.onInputDown.add(function() {
    this.frameSelector.framesGroup.y = 50;
    this.frameSelector.loadAtlas(this.atlas);
  },txt);

};


G.ModifyFrameSelector.prototype.createFrameButton = function(x,y,frame,tileSize,singleImgs) {

  var img = G.makeImage(x,y,frame,0,this.framesGroup);
  img.inputEnabled = true;
  img.FS = this;
  img.singleImgs = singleImgs;
  img.events.onInputDown.add(function() {
    console.log(this.key);
    this.FS.onFrameClicked.dispatch(this.singleImgs ? this.key : this.frameName);
  },img);
  img.input.useHandCursor = true;
  if (img.width > img.height) {
    img.width = tileSize*0.95;
    img.scale.y = img.scale.x;
  }else {
    img.height = tileSize*0.95;
    img.scale.x = img.scale.y;
  }

}
G.ModifyInputBlocked = function(){

  Phaser.Graphics.call(this,game,0,0);

  this.beginFill(0xff0000,0.0001);
  this.drawRect(0,0,5000,4000);
  this.inputEnabled=true;
  this.events.onInputDown.add(function(){});
  this.fixedToCamera = true;

};

G.ModifyInputBlocked.prototype = Object.create(Phaser.Graphics.prototype);
G.ModifyPropButton = function(modify, x,y,label,refreshFunc,setFunc,postSet){

  Phaser.Text.call(this,game,x,y,label+': ',{
    font: 'Verdana',
    backgroundColor: 'rgba(255,255,255,0.5)',
    fontSize: 15
  });

  this.label = label;

  this.modify = modify;

  if (typeof refreshFunc === 'string') {
    this.refreshProp = refreshFunc.split('.');
  }else {
    this.refreshFunc = refreshFunc;
  }

  if (typeof setFunc === 'string'){
    this.filterProperty = setFunc.slice(0,setFunc.indexOf(':'));
    this.setProp =  setFunc.slice(setFunc.indexOf(':')+1).split('.');
    this.setFunc = this.openInput;
  }else{
    this.setFunc = setFunc;
  }

  this.postSet = postSet;

  this.inputEnabled = true;
  this.input.useHandCursor = true;

  this.events.onInputDown.add(this.setFunc,this);

};

G.ModifyPropButton.prototype = Object.create(Phaser.Text.prototype);

G.ModifyPropButton.prototype.setFunc = function(){

  var obj = this.modify.getCurrentObject();

  if (!obj) return;

  var value = this[this.askFunc]();

  if (value === null) return;

  this.modify.modifyCurrentObjProp(this.refreshProp,value);

  if (this.postSet){
    this.postSet(obj,value);
  }

};

G.ModifyPropButton.prototype.openInput = function(){

  var obj = this.modify.getCurrentObject();

  this.modify.domLayer.openInputDiv(
    (obj.___LABEL || 'obj')+' | '+this.setProp,
    G.StorageUtils.getObjProp(obj,this.setProp),
    function(value){
      this.modify.modifyCurrentObjProp(this.refreshProp,value);
      if (this.postSet){
        this.postSet(obj,value);
      }
    },
    this,
    this.filterProperty);

};

G.ModifyPropButton.prototype.refreshFunc = function(obj){

  this.setText(this.label+': ---');

  var obj = this.modify.getCurrentObject();

  if (!obj) return;

  this.visible = true;
  var currentObj = obj;

  var val = G.StorageUtils.getObjProp(obj,this.refreshProp);

  if (val === undefined){
    this.visible = false;
  }else{
    if (typeof val === 'number'){
      val = val.toFixed(2);
    }

    this.setText(this.label+': '+val);
  }

};

G.ModifyPropButton.prototype.int = function() {
  var input = prompt(this.label || 'int');
  var parsedInput = parseInt(input);
  if (isNaN(parsedInput)) return null;

  return parsedInput;
};

G.ModifyPropButton.prototype.float = function() {
  var input = prompt(this.label || 'float');
  var parsedInput = parseFloat(input);
  if (isNaN(parsedInput)) return null;
  return parseFloat(parsedInput.toFixed(2));
};

G.ModifyPropButton.prototype.string = function(){
  return prompt(this.label || 'string');
};
G.ModifyPropGroup = function(modify){

  Phaser.Group.call(this,game);
  this.fixedToCamera = true;

  var name = new G.ModifyPropButton(modify,10,0,'name','name','number:name');
  this.add(name);

  var x = new G.ModifyPropButton(modify,10,10,'x','x','number:x');
  this.add(x);

  var y = new G.ModifyPropButton(modify,10,30,'y','y','number:y');
  this.add(y);

  var width = new G.ModifyPropButton(modify,10,50,'width','width','number:width');
  this.add(width);

  var height = new G.ModifyPropButton(modify,10,70,'height','height','number:height');
  this.add(height);

  var scaleX = new G.ModifyPropButton(modify,10,90,'scale.x','scale.x','number:scale.x');
  this.add(scaleX);

  var scaleY = new G.ModifyPropButton(modify,10,110,'scale.y','scale.y','number:scale.y');
  this.add(scaleY);

  var angle = new G.ModifyPropButton(modify,10,130,'angle','angle','number:angle');
  this.add(angle);

  var alpha = new G.ModifyPropButton(modify,10,150,'alpha','alpha','number:alpha');
  this.add(alpha);

  var visible = new G.ModifyPropButton(modify,10,170,'visible','visible',function(){
    var obj = this.modify.getCurrentObject();
    this.modify.modifyCurrentObjProp('visible',!obj.visible);
  });
  this.add(visible);

  var anchorX = new G.ModifyPropButton(modify,10,190,'anchor.x','anchor.x','number:anchor.x');
  this.add(anchorX);

  var anchorY = new G.ModifyPropButton(modify,10,210,'anchor.y','anchor.y','number:anchor.y');
  this.add(anchorY);

  var frame = new G.ModifyPropButton(modify,10,230,'frame','frameName',function(){
    modify.frameSelector.open();
  });
  this.add(frame);

  var fontSize = new G.ModifyPropButton(modify,10,250,'fontSize','fontSize','number:fontSize',function(obj,value){

    if (obj.cacheAsBitmap){
      obj.orgFontSize = value;
      if (obj.setText) obj.setText(obj.text);
    }

    //in case of labelgroup
    if (obj.refresh) obj.refresh();
  });
  this.add(fontSize);

  var font = new G.ModifyPropButton(modify,10,270,'font','font',function(){

    var obj = this.modify.getCurrentObject();

    var keys = Object.keys(game.cache._cache.bitmapFont);
    var fontIndex = keys.indexOf(obj.font);
    this.modify.modifyCurrentObjProp('font',keys[(fontIndex+1)%keys.length]);
    if (obj.cacheAsBitmap){
      if (obj.setText) obj.setText(obj.text);
    }

    //in case of labelgroup
    if (obj.refresh) obj.refresh();
  });
  this.add(font);

  var text = new G.ModifyPropButton(modify,10,290,'text','text','string:text',function(obj){
    if (obj.cacheAsBitmap){
      if (obj.setText) obj.setText(obj.text);
    }
  });
  this.add(text);


  var maxUserWidth = new G.ModifyPropButton(modify,10,310,'maxUserWidth','maxUserWidth','number:maxUserWidth',function(obj,value){
    if (obj.cacheAsBitmap){
      obj.setText(obj.text);
    }
  });
  this.add(maxUserWidth);

  var maxUserHeight = new G.ModifyPropButton(modify,10,330,'maxUserHeight','maxUserHeight','number:maxUserHeight',function(obj,value){
    if (obj.cacheAsBitmap){
      obj.setText(obj.text);
    }
  });
  this.add(maxUserHeight);


  var fixedToCamera = new G.ModifyPropButton(modify,10,350,'fixedToCamera','fixedToCamera',function(){
    var obj = this.modify.getCurrentObject();
    this.modify.modifyCurrentObjProp('fixedToCamera',!obj.fixedToCamera);
  });
  this.add(fixedToCamera);

  var cameraOffsetX = new G.ModifyPropButton(modify,10,370,'cameraOffset.x','cameraOffset.x','number:cameraOffset.x');
  this.add(cameraOffsetX);

  var cameraOffsetY = new G.ModifyPropButton(modify,10,390,'cameraOffset.y','cameraOffset.y','number:cameraOffset.y');
  this.add(cameraOffsetY);

  //(modify, x,y,label,refreshFunc,setFunc,postSet)

  var data = new G.ModifyPropButton(modify,10,420,'EXTRA_DATA',function(){

      var obj = this.modify.getCurrentObject();

      if (!obj) return;

      if (obj && obj.___DATA) {
        this.setText(this.label+': YES');
      }else {
        this.setText(this.label+': ---');
      }

  },function(){

    var obj = this.modify.getCurrentObject();

    this.modify.domLayer.openExtraData(obj.label, obj.___DATA || {},function(newData){

      //means empty string
      if (!newData) {
        delete obj.___DATA;
      }else {

        try {
          eval('var tmp = '+newData);

          if (typeof tmp === 'object'){
            obj.___DATA = tmp;
            //obj.___DATAPARSED = tmp;
          }else {
            console.warn('extra data cannot be a string');
          }

        }catch(e){
          console.warn('something went wrong with parsing value');
        }

      }

    });

  });
  this.add(data);


};

G.ModifyPropGroup.prototype = Object.create(Phaser.Group.prototype);

G.ModifyPropGroup.prototype.update = function(){

  var yy = 10;

  this.forEach(function(child,index){
    child.refreshFunc()
    if (child.visible) {
      child.y = yy;
      yy += 20;
    }
  });
  //this.cameraOffset.y = this.groupTxt.cameraOffset.y+this.groupTxt.height+50;

};

if (typeof G == 'undefined') G = {};

G.Mover = function(groupToMove) {

 Phaser.Group.call(this,game);

 this.groupToMove = groupToMove;

 this.currentIndex = 0;

 this.keys = game.input.keyboard.addKeys({z: Phaser.Keyboard.Z, x: Phaser.Keyboard.X, c: Phaser.Keyboard.C, minus: Phaser.Keyboard.MINUS, plus: Phaser.Keyboard.PLUS});

 this.keys.plus.onDown.add(function() {
  if (!this.grouptoMove) return;
  this.currentIndex++;
  this.currentIndex = this.currentIndex % this.groupToMove.length;
 },this);

 this.keys.minus.onDown.add(function() {
  if (!this.grouptoMove) return;
  this.currentIndex--;
  if (this.currentIndex == -1) this.currentIndex = this.groupToMove.length-1;
 },this);

 this.cursors = game.input.keyboard.createCursorKeys();


};

G.Mover.prototype = Object.create(Phaser.Group.prototype);


G.Mover.prototype.update = function() {

  if (!this.groupToMove) return;

  var val = 1;

  if (this.keys.z.isDown) {
    val = 5;
  }
  if (this.keys.x.isDown) {
    val = 10;
  }
  if (this.keys.c.isDown) {
    val = 20;
  }


  if (this.cursors.up.isDown) {
    this.groupToMove.children[this.currentIndex].y -= val;
  }

  if (this.cursors.down.isDown) {
    this.groupToMove.children[this.currentIndex].y += val;
  }

  if (this.cursors.left.isDown) {
    this.groupToMove.children[this.currentIndex].x -= val;
  }

  if (this.cursors.left.isDown) {
    this.groupToMove.children[this.currentIndex].x += val;
  }

};